

























































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ConfirmationDialog extends Vue {

    @Prop({default:'', type: String})
    tooltip!: string;

    @Prop({default: false, type: Boolean})
    customize: boolean

    @Prop({default: 'Confirm'})
    btnText!: string;

    @Prop({default: 'Are you sure?'})
    text!: string;

    @Prop({default: 'Confirm Action'})
    dialogTitle!: string;

    @Prop({default: 'primary'})
    btnColor!: string;

    @Prop({default: null})
    emitData!: any;

    @Prop({default: null})
    icon!: string;

    @Prop({default: "default"})
    iconSize!: string;

    @Prop({default: "default"})
    size!: string;

    @Prop({default: ""})
    iconColour!: string;

    @Prop({default: false})
    loading!: boolean;

    @Prop({default: false, type: Boolean})
    disabled!: boolean;

    @Prop({default: false})
    depressed!: boolean;

    @Prop({default: false})
    outlined!: boolean;

    @Prop()
    innerClass!: string;

    @Prop({default: false})
    transparent!: boolean;
    
    @Prop({default: false})
    isCustomSlot!: boolean;
    private dialog: boolean = false;

    created() {
        document.addEventListener('keydown', this.keyActions, true);
    }

    beforeDestroy() {
        document.removeEventListener('keydown', this.keyActions, true);
    }

    @Watch('disabled')
    private disabledChange(newVal: boolean, oldVal: boolean) {
        if (newVal) {
            this.dialog = false;
        }
    }

    private keyActions(e: any) {
        if (this.dialog) {
            if (e.key == 'Enter') {
                this.agree();
            }
            if (e.key == 'Escape') {
                this.disagree();
            }
        }
    }

    @Emit('agree')
    private agree() {
        this.dialog = false;
        return this.emitData
    }

    @Emit('disagree')
    private disagree() {
        this.dialog = false;
        return this.emitData
    }

}
